// extracted by mini-css-extract-plugin
export var container = "_5s-0";
export var disabled = "_5s-4";
export var fullWidth = "_5s-3";
export var lined = "_5s-1";
export var selected = "_5s-5";
export var tab = "_5s-2";